import { RATING_FACET_ALL_REVIEWED } from '../../Facet/components/StarRatingFacet/localization-tokens';
import { Option } from '../../types';

const formatDashIntoEmDash = (name = '') => (
  (name ?? '').replace('-', '–')
);

const getDefaultDisplayName = (tagDisplayLabel?: string, name?: string, searchFacetOptionValue?: string): string | undefined => (
  tagDisplayLabel ?? name ?? searchFacetOptionValue
);


const getDisplayName = (localize: (token: string) => string) => ({ facetName, tagDisplayLabel, name, searchFacetOptionValue, id }: Option): string | undefined => {
  if (facetName === 'reviewScore' && id === '1') {
    return localize(RATING_FACET_ALL_REVIEWED);
  }

  return getDefaultDisplayName(tagDisplayLabel, name, searchFacetOptionValue);
};

const getAppliedOptionsAsText = (appliedFacets: { [key: string]: Option[] }, facetName: string, localize: (token: any ) => any ) => {
  const appliedOptions = appliedFacets[facetName] || [];
  return appliedOptions.map(getDisplayName(localize))
    .map(formatDashIntoEmDash)
    .join(', ');
};

export default getAppliedOptionsAsText;
